module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../biz-b2c-web-h5/config/loader/esbuild-loader/esbuild-loader.js!../../../../../biz-b2c-web-h5/config/loader/esbuild-loader/esbuild-loader.js!./index.tsx"));
	}, "priaView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=priaView!../biz-micro-services-ui/project/pria/pages/income/index.tsx
// module id = 1622
// module chunks = 418